import * as React from "react";
import { Form, DatePicker, InputNumber, Divider } from "antd";
import {
  DateFormats,
  RandomSelectionConstants
} from "../../../common/Constants";
import Text from "antd/lib/typography/Text";
import { TRandomSelectionPresentationModel } from "../../../presenter/reporting/ReportingPeriodPresenter";
import moment from "moment";

const RandomSelectionForm = ({
  getFieldDecorator,
  translate,
  percentage,
  data
}: {
  getFieldDecorator: any;
  translate: any;
  percentage?: number;
  data?: TRandomSelectionPresentationModel;
}) => {
  return (
    <Form>
      <Form.Item label={translate("random_selection.percentage")}>
        {getFieldDecorator(
          RandomSelectionConstants.FIELDS.PERCENTAGE_OF_CANDIDATES,
          {
            initialValue:
              data?.percentageOfCandidates ?? percentage ?? undefined,
            rules: [
              {
                required: true,
                message: translate("random_selection.required_messages", {
                  field: translate("random_selection.percentage")
                })
              }
            ]
          }
        )(<InputNumber min={0} max={100} />)}
      </Form.Item>

      <Divider></Divider>

      <div className="ant-form-row-container">
        <Text style={{ fontWeight: "bold" }}>
          {translate("random_selection.period")}
        </Text>

        <div className="ant-form-row-two-items">
          <Form.Item
            label={translate("random_selection.period_from")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(RandomSelectionConstants.FIELDS.PERIOD_FROM, {
              initialValue: data?.periodFrom
                ? moment(data.periodFrom)
                : undefined
            })(
              <DatePicker
                placeholder={translate("random_selection.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
              />
            )}
          </Form.Item>
          <Form.Item
            label={translate("random_selection.period_to")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(RandomSelectionConstants.FIELDS.PERIOD_TO, {
              initialValue: data?.periodTo ? moment(data.periodTo) : undefined
            })(
              <DatePicker
                placeholder={translate("random_selection.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
              />
            )}
          </Form.Item>
        </div>
      </div>

      <Divider />

      <div className="ant-form-row-container">
        <Text style={{ fontWeight: "bold" }}>
          {translate("random_selection.number_additional_checks")}
        </Text>

        <div className="ant-form-row-two-items">
          <Form.Item
            label={translate("random_selection.min")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(RandomSelectionConstants.FIELDS.MIN, {
              initialValue: data?.min ?? undefined
            })(<InputNumber min={0} />)}
          </Form.Item>
          <Form.Item
            label={translate("random_selection.max")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(RandomSelectionConstants.FIELDS.MAX, {
              initialValue: data?.max ?? undefined
            })(<InputNumber min={0} />)}
          </Form.Item>
        </div>
      </div>
    </Form>
  );
};

export default RandomSelectionForm;
